export interface LearningExperienceInfo {
  name: string;
  description: string;
  iconLigature: string;
}

export enum LearningExperienceName {
  VIRTUAL_CLASS = 'Virtual Class',
  BOOK_CLUB = 'Book Club',
  CLASSROOM = 'Classroom',
  READING_PLAN = 'Reading Plan',
  LEARNING_CLUB = 'Learning Club',
  LEARNING_PATH = 'Learning Path',
  TEAM_CHALLENGE = 'Team Challenge',
  DEEP_LEARNING = 'Deep Learning',
  ESSENTIAL_TRAINING = 'Essential Training',
  DISCOVERY = 'Discovery',
  STUDENTS = 'Students & Alumni Club',
  PROJECT_BASED = 'Project Based',
  GAIN_SKILL = 'Gain a Skill',
  CLASS = 'Class',
  ONBOARDING = 'Onboarding',
  PEER_TRANSFER = 'Peer Transfer',
  ACTIVE_METHODOLOGIES = 'Active Methodologies',
  CAREER_DEVELOPMENT = 'Career Development',
  CERTIFIED_PATH = 'Certified Path',
  COHORT_LEARNING = 'Cohort Learning',
  COMMUNITY_EXPERIENCE = 'Community Experience',
  CAS = 'Método del Caso',
  FLI = 'Aprendizaje Invertido',
  SIM = 'Aprendizaje Basado en Simulación',
  RET = 'Aprendizaje Basado en Reto',
  ABP = 'Aprendizaje Basado en Proyectos',
  PRO = 'Aprendizaje Basado en Problemas',
}

export const experiencesDescriptions: LearningExperienceInfo[] = [
  {
    name: LearningExperienceName.VIRTUAL_CLASS.valueOf(),
    description: 'experiences.info.description.virtualClass',
    iconLigature: 'le_01',
  },
  {
    name: LearningExperienceName.BOOK_CLUB.valueOf(),
    description: 'experiences.info.description.bookclub',
    iconLigature: 'le_06',
  },
  {
    name: LearningExperienceName.CLASSROOM.valueOf(),
    description: 'experiences.info.description.classroom',
    iconLigature: 'le_07',
  },
  {
    name: LearningExperienceName.READING_PLAN.valueOf(),
    description: 'experiences.info.description.readingPlan',
    iconLigature: 'le_08',
  },
  {
    name: LearningExperienceName.LEARNING_CLUB.valueOf(),
    description: 'experiences.info.description.learningClub',
    iconLigature: 'le_09',
  },
  {
    name: LearningExperienceName.LEARNING_PATH.valueOf(),
    description: 'experiences.info.description.learningPath',
    iconLigature: 'le_10',
  },
  {
    name: LearningExperienceName.TEAM_CHALLENGE.valueOf(),
    description: 'experiences.info.description.teamChallenge',
    iconLigature: 'le_11',
  },
  {
    name: LearningExperienceName.DEEP_LEARNING.valueOf(),
    description: 'experiences.info.description.deepLearning',
    iconLigature: 'le_12',
  },
  {
    name: LearningExperienceName.ESSENTIAL_TRAINING.valueOf(),
    description: 'experiences.info.description.essentialTraining',
    iconLigature: 'le_13',
  },
  {
    name: LearningExperienceName.DISCOVERY.valueOf(),
    description: 'experiences.info.description.discovery',
    iconLigature: 'le_14',
  },
  {
    name: LearningExperienceName.STUDENTS.valueOf(),
    description: 'experiences.info.description.students',
    iconLigature: 'le_15',
  },
  {
    name: LearningExperienceName.PROJECT_BASED.valueOf(),
    description: 'experiences.info.description.projectBased',
    iconLigature: 'le_16',
  },
  {
    name: LearningExperienceName.GAIN_SKILL.valueOf(),
    description: 'experiences.info.description.gainSkill',
    iconLigature: 'le_17',
  },
  {
    name: LearningExperienceName.CLASS.valueOf(),
    description: 'experiences.info.description.class',
    iconLigature: 'le_03',
  },
  {
    name: LearningExperienceName.ONBOARDING.valueOf(),
    description: 'experiences.info.description.onboarding',
    iconLigature: 'le_08',
  },
  {
    name: LearningExperienceName.PEER_TRANSFER.valueOf(),
    description: 'experiences.info.description.peerTransfer',
    iconLigature: 'le_07',
  },
  {
    name: LearningExperienceName.ACTIVE_METHODOLOGIES.valueOf(),
    description: 'experiences.info.description.activeMethodologies',
    iconLigature: 'le_02',
  },
  {
    name: LearningExperienceName.CAREER_DEVELOPMENT.valueOf(),
    description: 'experiences.info.description.careerDevelopment',
    iconLigature: 'le_01',
  },
  {
    name: LearningExperienceName.CERTIFIED_PATH.valueOf(),
    description: 'experiences.info.description.certifiedPath',
    iconLigature: 'le_10',
  },
  {
    name: LearningExperienceName.COHORT_LEARNING.valueOf(),
    description: 'experiences.info.description.cohortLearning',
    iconLigature: 'le_04',
  },
  {
    name: LearningExperienceName.COMMUNITY_EXPERIENCE.valueOf(),
    description: 'experiences.info.description.communityExperience',
    iconLigature: 'le_15',
  },
  {
    name: LearningExperienceName.CAS.valueOf(),
    description: 'experiences.info.description.cas',
    iconLigature: 'le_15',
  },
  {
    name: LearningExperienceName.FLI.valueOf(),
    description: 'experiences.info.description.fli',
    iconLigature: 'le_03',
  },
  {
    name: LearningExperienceName.SIM.valueOf(),
    description: 'experiences.info.description.sim',
    iconLigature: 'le_14',
  },
  {
    name: LearningExperienceName.RET.valueOf(),
    description: 'experiences.info.description.ret',
    iconLigature: 'le_12',
  },
  {
    name: LearningExperienceName.ABP.valueOf(),
    description: 'experiences.info.description.abp',
    iconLigature: 'le_13',
  },
  {
    name: LearningExperienceName.PRO.valueOf(),
    description: 'experiences.info.description.pro',
    iconLigature: 'le_04',
  },
];
// FOLLOWS THE EXPERIENCE | MODERATES THE EXPERIENCE | NO ENRICHMENT
export enum ExperienceType {
  FOLLOWING = 'FOLLOWING',
  MODERATES = 'MODERATES',
  PLAIN = 'PLAIN',
}
